// Installs the error report handlers of the page when it evaluates
// (fault-reports.md §2, R1582). A page's `main.ts` imports this module
// second, after the boot error painter, so a fault in the evaluation of
// any later module is reported too. `net/faultreport.ts` holds the rules.
// The client log starts here as well (`net/clientlog.ts`, R1627), so the
// REPORT sheet carries the console lines of the whole page load.
import { installClientLog } from './clientlog';
import { installFaultReports } from './faultreport';

installFaultReports();
installClientLog();
